<ll-titulo>Crear usuario</ll-titulo>
<ll-toolnavbar>
    <cuentas-admin-toolnavbar [displayButtons]="'all'"></cuentas-admin-toolnavbar>
</ll-toolnavbar>

<cuentas-new></cuentas-new>
